import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // Human-readable scope links, e.g. /temasek-polytechnic (a team) or
  // /org/green-school-network (a superteam). The segment is a slug — lowercase,
  // hyphenated — which Home resolves to an id against the teams endpoint and
  // applies as a filter. Teams and superteams get separate namespaces so a slug
  // shared between one of each is never ambiguous.
  //
  // These paths are the canonical form the dashboard writes back for a scoped
  // view (see src/utils/urlFilters.js); the ?team= / ?superteam= id params are
  // kept only for links made before slugs existed, and for a row whose slug the
  // backend didn't return.
  //
  // A bare /org carries no superteam, and would otherwise fall through to
  // /:slug and be looked up as a team named "org" — send it to the unscoped
  // dashboard instead. Declared before /:slug, which matches in declaration
  // order. (Two-segment /org/x can't match single-segment /:slug at all.)
  {
    path: "/org",
    redirect: "/",
  },
  {
    path: "/org/:slug",
    name: "SuperteamScope",
    component: Home,
  },
  // A superteam drilled into one of its child teams: both scopes as slugs, the
  // parent first. Declared before /org/:slug would matter only if that pattern
  // could match two segments — it can't — so order is irrelevant here.
  {
    path: "/org/:slug/:teamSlug",
    name: "SuperteamTeamScope",
    component: Home,
  },
  {
    path: "/:slug",
    name: "TeamScope",
    component: Home,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
